exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buyingcard[data-v-a1aadf52] {\n  padding: 8px 15px 8px 15px;\n}\n.buyingcard .title[data-v-a1aadf52] {\n  color: #999;\n  font-size: 17px;\n}\n.buyingcard .value[data-v-a1aadf52] {\n  font-size: 17px;\n  color: unset;\n}\n.image .image1[data-v-a1aadf52] {\n  display: block;\n  padding-right: 15px;\n  margin: auto;\n  max-height: 80px;\n}\n.remove[data-v-a1aadf52] {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 9999;\n}\n.no-favorites[data-v-a1aadf52] {\n  text-align: center;\n}", ""]);

// exports
